export const BoundaryTerritoryListingLimit = 20;
export const BoundaryTerritoryListingExportLimit = 100;
